module.exports = __webpack_public_path__ + "static/pod-become-911cd3c24f3bba1ff19c9d766a9d97a8.jpg";